import * as React from "react";
import svgIcons from "../../assets/svg/svgIcons";
import ImgRefLandingPage from "../../assets/images/ref_landing_page.png";
import { useDispatch, useSelector } from "react-redux";
import { setModalsData, TModalsState } from "../../api/store/commonSlice";

const ModalReference = () => {
  const dispatch = useDispatch();
  const modalsState: TModalsState = useSelector(
    (state: any) => state.commonReducer.modals
  );
  const hideModal = () => {
    dispatch(
      setModalsData({ ...modalsState, showReferenceLandingModal: false })
    );
  };
  if (!modalsState.showReferenceLandingModal) return null;
  return (
    <>
      <div
        className="fixed w-full h-screen top-0 left-0 bg-modal-overlay z-overlay"
        onClick={hideModal}
      />
      <div
        className={
          "fixed inset-y-1/2 inset-x-1/2 w-[calc(100vw-6rem)] h-[calc(100vh-6rem)] bg-black/80 overflow-hidden " +
          "Xbg-white rounded-xl shadow-lg z-modal pb-20"
        }
        style={{ transform: "translate(-50%, -50%)" }}
      >
        <button
          className="group size-10 flex items-center justify-center rounded-full bg-black hover:bg-gray-100 focus:ring focus:ring-white outline-0"
          onClick={hideModal}
        >
          <img
            src={svgIcons.CloseIcon}
            alt="Close"
            className="grayscale-0 brightness-0 invert group-hover:invert-0 opacity-50"
          />
        </button>
        <img
          src={ImgRefLandingPage}
          alt="reference"
          className="h-full w-full"
          style={{ objectFit: "contain" }}
        />
      </div>
    </>
  );
};

export default ModalReference;
